module.exports = __webpack_public_path__ + "img/order.96a7a971.svg";